import { render, staticRenderFns } from "./productBrand.vue?vue&type=template&id=088e17d0&scoped=true&"
import script from "./productBrand.vue?vue&type=script&lang=js&"
export * from "./productBrand.vue?vue&type=script&lang=js&"
import style0 from "./productBrand.vue?vue&type=style&index=0&id=088e17d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e17d0",
  null
  
)

component.options.__file = "productBrand.vue"
export default component.exports